module.exports = __webpack_public_path__ + "img/4.ec6a166c.png";